import Vue from 'vue';
import Vuex from 'vuex';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import VueSocialSharing from 'vue-social-sharing';
import VueMeta from 'vue-meta';
import Embed from 'v-video-embed';
import PortalVue from 'portal-vue';
import { Loader } from '@googlemaps/js-api-loader';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import { InertiaProgress } from '@inertiajs/progress';
import { App, plugin } from '@inertiajs/inertia-vue';

import Button from '@/Components/Button';
import Card from '@/Components/Card';
import Checkbox from '@/Components/Checkbox';
import Font from '@/Components/Font';
import IconButton from '@/Components/IconButton';
import Input from '@/Components/Input';
import InputError from '@/Components/InputError';
import Link from '@/Components/Link';
import SgLoader from '@/Components/Loader';
import Spacing from '@/Components/Spacing';
import Text from '@/Components/Text';
import Title from '@/Components/Title';
import Toast from '@/Components/Toast';
import Label from '@/Components/Label';
import TextArea from '@/Components/TextArea';

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

InertiaProgress.init();

if (window.env?.APP_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: window.env.SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: window.env?.SENTRY_TRACES_SAMPLE_RATE,
  });
}

Vue.use(Vuex);
Vue.use(Embed);
Vue.use(plugin);
Vue.use(VueMeta);
Vue.use(PortalVue);
Vue.use(VueAwesomeSwiper);
Vue.mixin({ methods: { route } });
Vue.use(VueSocialSharing, {
  networks: {
    sms: 'sms:&body=@t%20@u',
    email: 'mailto:?subject=@t&body=@u',
  },
});

// App Components
Vue.component('sg-button', Button);
Vue.component('sg-card', Card);
Vue.component('sg-checkbox', Checkbox);
Vue.component('sg-font', Font);
Vue.component('sg-icon-button', IconButton);
Vue.component('sg-input', Input);
Vue.component('sg-input-error', InputError);
Vue.component('sg-label', Label);
Vue.component('sg-link', Link);
Vue.component('sg-loader', SgLoader);
Vue.component('sg-spacing', Spacing);
Vue.component('sg-text', Text);
Vue.component('sg-textarea', TextArea);
Vue.component('sg-title', Title);
Vue.component('sg-toast', Toast);

const app = document.getElementById('app');

const store = new Vuex.Store({
  state: {
    showingFeedback: false,
    showingShare: false,
  },
  mutations: {
    hideFeedback(state) {
      state.showingFeedback = false;
    },
    showFeedback(state) {
      state.showingFeedback = true;
    },
    hideShare(state) {
      state.showingShare = false;
    },
    showShare(state) {
      state.showingShare = true;
    },
  },
});

new Loader({
  apiKey: window.env.GOOGLE_MAPS_KEY,
  libraries: ['places'],
})
  .load()
  .then(
    function(googleApi) {
      new Vue({
        data: {
          loaded: false,
        },

        metaInfo: {
          titleTemplate: title => (title ? `${title} - SessionGuide` : 'SessionGuide'),
        },

        render: h =>
          h(App, {
            props: {
              initialPage: JSON.parse(app.dataset.page),
              resolveComponent: name => import(`@/Pages/${name}`).then(module => module.default),
            },
          }),

        store,
      }).$mount(app);
    },
    function(err) {
      console.error(err);
    },
  );
